export enum VISIBILITY_STATE {
    hidden = 'hidden',
    visible = 'visible',
}

// 参考文档 https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/2tsPs8CtSd/ZzIjzst2PP/ov6ttthABEvNYR
export const sourceType = {
    104: 104,
    107: 107,
    108: 108,
};

export enum HistoryModeTabValue {
    History = 'history',
    Version = 'version',
}
